import React from "react"
import { SignIn } from "@clerk/clerk-react"
import { Grid, Card, CardMedia } from "@mui/material"
import logo from "../../images/logo.png"

const Login = () => {
  return (
    <Grid
      container
      direction="row"
      justifyContent="center"
      alignItems="center"
      style={{ height: "calc(100vh)" }}
    >
      <Grid item>
        <Card style={{ padding: "20px" }}>
          <CardMedia
            component="img"
            height="200"
            alt="Cweed Logo"
            image={logo}
            style={{ marginBottom: "20px" }}
          />
          <SignIn />
        </Card>
      </Grid>
    </Grid>
  )
}

export default Login
